/* eslint-disable react/no-array-index-key */
import React from 'react';
import classnames from 'classnames';

import Tag from 'components/Utils/Tag';

import styles from './index.module.scss';

interface IProps {
    classname?: string;
    category: string;
    title: string;
    tags?: ITag[];
}

const Card: React.FC<IProps> = ({
    classname, category, title, tags
}): JSX.Element => {
    const newCategory = `${category.substring(0, 2)}\n${category.substring(2)}`;
    return (
        <div className={classnames(classname, styles.card)}>
            <div className={styles.category}>
                {newCategory.split('\n').map((line, index) => (<span key={`line-${index}`}>{line}</span>))}
            </div>
            <div className={styles.content}>
                <div className={styles.title}>{title}</div>
                <div className={styles.tagContainer}>
                    {tags?.map((t: ITag) => (
                        <Tag text={t.name} key={t.id} />
                    ))}
                </div>
            </div>
        </div>
    );
};

Card.defaultProps = {
    classname: '',
    tags: [],
};

export default Card;
